export default __webpack_public_path__ + "static/media/image.a085ee65.jpg";